export default __webpack_public_path__ + "media/images/elements/14-16d68e8aeef75d5d58151aed916efe8f.png";